import { BentResponse } from 'bent';
import { httpClient } from 'utils/httpClient';

const url = process.env.REACT_APP_NOTIF_SERVICE_URL;

export const checkPhoneNumber = (number: string) =>
  httpClient('PUT', url!, 204)(`/validator/phoneNumber:validateFormat`, { number }) as Promise<BentResponse>;
